import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

VIV.behaviours.header = (function () {

    // Attach behaviour
    const attach = function (context) {
        const baseClass = 'header';
        context.querySelectorAll(`.${baseClass}`).forEach(element => {
            initHeader(element);
        });
    };

    const initHeader = function (header) {
        const links = header.querySelectorAll('.menu__link--hasChildren');
        const allTargets = header.querySelectorAll('.header__submenu');
        links.forEach(link => {
            link.addEventListener('click', function (event) {
                event.preventDefault();

                const targetSelector = link.getAttribute('href');
                const target = header.querySelector(targetSelector);
                const isOpen = link.classList.toggle('menu__link--open');

                allTargets.forEach(target => {
                    target.style.display = 'none';
                });
                target.style.display = isOpen ? 'block' : 'none';

                links.forEach(otherLink => {
                    if (otherLink !== link) {
                        otherLink.classList.remove('menu__link--open');
                    }
                });

                document.documentElement.classList.toggle('menuIsOpen', isOpen);

                if (isOpen) {
                    disableBodyScroll(target);
                } else {
                    enableBodyScroll(target);
                }
            });
        });
    }

    return {
        attach: attach
    }
})();
